export default __webpack_public_path__ + "static/media/ttaVerifiedBadge.9ef509b8.svg";